import { Button, message, Modal } from "antd";
import { useState } from "react";
import { DesignDto, MenuFolderDto } from "../../generated/dashboard-client";
import "./MoveToFolderModal.scss";
import DesignApi from "../../api/DesignApi";

export interface RemoveDesignFromFolderModalProps {
  isVisible: boolean;
  folder: MenuFolderDto | null;
  design: DesignDto | null;
  onClose: (designIds: string[]) => void;
}

export function RemoveDesignFromFolderModal({
  isVisible,
  folder,
  design,
  onClose,
}: RemoveDesignFromFolderModalProps) {
  const [removing, setRemoving] = useState(false);

  function remove() {
    setRemoving(true);
    if (!design || !folder) {
      return;
    }

    DesignApi.removeFromFolder([design.id!])
    .then(() => {
      setRemoving(false);
      onClose([design.id!]);
    })
    .catch(() => {
      setRemoving(false);
      message.error("Error removing design from folder");
    });
  }

  return (
    <Modal
      className={"clean one"}
      visible={isVisible}
      onCancel={() => onClose([])}
    >
      <header>
        <h2>Remove design from folder</h2>
      </header>

      <p>
        Are you sure you want to remove this design from {folder?.name} folder?
      </p>

      <footer>
        <Button size={"large"} onClick={() => onClose([])}>
          Cancel
        </Button>
        <Button
          size={"large"}
          className={"primary"}
          onClick={remove}
          disabled={!folder || !design}
          loading={removing}
        >
          Remove
        </Button>
      </footer>
    </Modal>
  );
}
